import { useCallback, useEffect, useState } from 'react';
import type { AtMentionEntity } from '@/config/static/mentions';
import { PROVISIONED_USERS_CHANGED_EVENT } from '@/utils/constants';
import { listUsers, toMentionEntities } from '@/services/userRegistry';
import type { ProvisionedUser } from '@/types/provisionedUser';

export function useProvisionedUsers() {
  const [users, setUsers] = useState<ProvisionedUser[]>(() => listUsers());
  const [mentionEntities, setMentionEntities] = useState<AtMentionEntity[]>(() =>
    toMentionEntities()
  );

  const refresh = useCallback(() => {
    setUsers(listUsers());
    setMentionEntities(toMentionEntities());
  }, []);

  useEffect(() => {
    const onChange = () => refresh();
    window.addEventListener(PROVISIONED_USERS_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(PROVISIONED_USERS_CHANGED_EVENT, onChange);
  }, [refresh]);

  return { users, mentionEntities, refresh };
}
